import React, { useState, useEffect } from "react";
import { DirectionsRenderer } from "@react-google-maps/api";

const DirectionsServiceComponent = ({ locationsData }) => {
  const [directionsResponse, setDirectionsResponse] = useState(null);

  useEffect(() => {
    if (locationsData?.length < 2) return;

    const directionsService = new window.google.maps.DirectionsService();

    const waypoints = locationsData.slice(1, -1).map((location) => ({
      location: { lat: location.lat, lng: location.lng },
      stopover: true,
    }));

    directionsService.route(
      {
        origin: { lat: locationsData[0].lat, lng: locationsData[0].lng },
        destination: {
          lat: locationsData[locationsData?.length - 1].lat,
          lng: locationsData[locationsData?.length - 1].lng,
        },
        waypoints,
        travelMode: window.google.maps.TravelMode.DRIVING,
      },
      (result, status) => {
        if (status === "OK") {
          setDirectionsResponse(result);
        } else {
          console.error("Directions request failed due to " + status);
        }
      }
    );
  }, [locationsData]);

  return directionsResponse ? (
    <DirectionsRenderer directions={directionsResponse} />
  ) : null;
};

export default DirectionsServiceComponent;
